import { getFriendlyDocumentType } from "../../../manager/pages/document-search/document-types";

interface IDocument {
  id: string;
  date?: string;
  file_name: string;
  file_type: string;
  content: string;
  alertcase_id?: string;
  alertcase_title?: string;
  alertcase_number?: string;
}

export function transformToBackendDocument(data: IDocument[]) {
  return {
    documents: data.map(document => ({
      id: document.id,
      file_name: document.file_name,
      file_type: document.file_type,
    })),
  };
}

export function transformFromBackendDocument(backendType: IDocument[]) {
  return backendType.map(document => ({
    id: document.id,
    date: document.date,
    file_name: document.file_name,
    file_type: getFriendlyDocumentType(document.file_type),
    content: document.content,
    alertcase_id: document.alertcase_id,
    alertcase_title: document.alertcase_title,
    alertcase_number: document.alertcase_number
  }));
}
